import React, { Component } from "react";
import PT from "prop-types";
import _ from "lodash";
import styled, { keyframes } from "styled-components";
import { Slider, Modal, ButtonGroup, Button } from "../components"; // Modal
import { ComingSoon } from "../containers"; // TypeResidenceVirtual,
import { getOrdinalSuffixWithElement } from "../utils";
import GalleryLightbox from "../components/GalleryLightbox";

const pulse = keyframes`
  0% {
    transform: scale(0.4);
    opacity: 0;
  }

  70% {
    transform: scale(0.9);
    opacity: 0.8;
  }

  75% {
    transform: scale(0.75);
    opacity: 0.2;
  }

  85% {
    transform: scale(0.6);
    opacity: 0.2;
  }

  100% {
    transform: scale(0.6);
    opacity: 0.2;
  }
`;

const AnimatedBubble = styled.g`
  animation: ${pulse} 2s infinite;
`;

class TypeResidences extends Component {
  static propTypes = {
    data: PT.arrayOf(PT.shape()),
    viewBox: PT.object.isRequired,
    t: PT.func,
    currentSection: PT.number,
  };
  // x: PT.arrayOf(PT.number),
  // y: PT.arrayOf(PT.number)
  static defaultProps = {
    data: [],
    viewBox: {
      x: 0,
      y: 0,
      width: 1920,
      height: 1080,
    },
    t: () => {},
    currentSection: 0,
  };
  state = {
    currentSection: 0,
    showImageModal: false,
    showVirtualModal: false,
    currentImage: 0,
    currentURL: "",
  };
  componentDidMount = () => {
    // typeresidence-container-des
    this.calPositionResDes();
  };
  componentDidUpdate = () => {
    this.calPositionResDes();
  };
  calPositionResDes = () => {
    try {
      const heightBtnGroup =
        document.querySelector(".typeresidence-container-btn").clientHeight ||
        80;
      document.querySelector(
        ".typeresidence-container-des"
      ).style.bottom = `${heightBtnGroup + 40}px`;
    } catch (error) {
      console.error(error);
    }
  };
  componentWillMount() {
    this.setState({ currentSection: 0 });
  }
  componentWillReceiveProps(nextProps) {
    // console.log('componentWillReceiveProps >>>> ', nextProps);
    if (this.state.currentSection !== nextProps.currentSection) {
      this.setState({ currentSection: nextProps.currentSection });
    }
  }
  createSliderData = () => {
    const { currentSection } = this.state;
    const { data } = this.props;
    const eachSlider = _.get(data[0], `buttons[${currentSection}].images`);
    return eachSlider;
  };
  createBtn = () => {
    const { data, t } = this.props;
    const { currentSection } = this.state;
    const allBtn = _.get(data[0], "buttons");
    const renderBtn = (
      <ButtonGroup
        value={currentSection}
        items={allBtn}
        onChange={(value) => this.setState({ currentSection: value })}
        direction="horizontal"
        renderItem={({ value, name, active, onClick, key }) => {
          return (
            <Button
              key={key}
              type="secondary"
              active={active}
              activeStyle={{ backgroundColor: "#00a9a5" }}
              hoverStyle={{ backgroundColor: "#00a9a5" }}
              page="residence"
              defaultStyle={{
                padding: "10px 15px",
                marginRight: "1px",
                fontWeight: "bold",
                fontSize: "13px",
                letterSpacing: "1px",
              }}
              onClick={() => this.setState({ currentSection: key })}
            >
              {getOrdinalSuffixWithElement(t(name))}
              {/* {t(name)} */}
            </Button>
          );
        }}
      />
    );
    return renderBtn;
  };
  handleClickSection = (key) => {
    this.setState({ currentSection: key });
  };
  createimageImage = () => {
    const { data } = this.props;
    const { currentSection } = this.state;
    const dataVirtual = _.get(data[0], `buttons[${currentSection}].image360`);
    return _.map(dataVirtual, (item, key) => {
      const translateAdd = `translate(${item.x},${item.y})`;
      // const currentImageIndex = _.get(item, "currentIndex", 0);
      const currentImageIndex = key;
      return (
        <g key={key} transform={translateAdd}>
          <radialGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="10%"
              style={{ stopColor: "#666666", stopOpacity: 1 }}
            />
            <stop
              offset="90%"
              style={{ stopColor: "#7f7e7e", stopOpacity: 0.2 }}
            />
          </radialGradient>
          <AnimatedBubble>
            <circle
              cx={0}
              cy={0}
              r="55"
              stroke="#666666"
              stroke-width="0"
              fill="url(#grad1)"
              opacity="1"
              onClick={() => this.handleClickImage(currentImageIndex)}
            />
          </AnimatedBubble>
          <g className="animatedBubble">
            <circle
              cx={0}
              cy={0}
              r="30"
              stroke="#666666"
              stroke-width="3"
              fill="#666666"
              onClick={() => this.handleClickImage(currentImageIndex)}
            />
            <image
              xlinkHref="/assets/images/icon-image.png"
              x={-22}
              y={-23}
              width={45}
              height={45}
              onClick={() => this.handleClickImage(currentImageIndex)}
            />
          </g>
        </g>
      );
    });
  };
  createimage360 = () => {
    const { data } = this.props;
    const { currentSection } = this.state;
    const dataVirtual = _.get(
      data[0],
      `buttons[${currentSection}].imageVirtual`
    );
    return _.map(dataVirtual, (item, key) => {
      const translateAdd = `translate(${item.x},${item.y})`;
      return (
        <g transform={translateAdd}>
          <radialGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="10%"
              style={{ stopColor: "#666666", stopOpacity: 1 }}
            />
            <stop
              offset="90%"
              style={{ stopColor: "#7f7e7e", stopOpacity: 0.2 }}
            />
          </radialGradient>
          <AnimatedBubble>
            <circle
              cx={0}
              cy={0}
              r="55"
              stroke="#666666"
              stroke-width="0"
              fill="url(#grad1)"
              opacity="1"
              onClick={() => this.handleClick360(item.path)}
            />
          </AnimatedBubble>
          <g className="animatedBubble">
            <circle
              cx={0}
              cy={0}
              r="30"
              stroke="#666666"
              stroke-width="3"
              fill="#666666"
              onClick={() => this.handleClick360(item.path)}
            />
            <image
              xlinkHref="/assets/images/icon-360.png"
              x={-23}
              y={-20}
              width={45}
              height={45}
              onClick={() => this.handleClick360(item.path)}
            />
          </g>
        </g>
      );
    });
  };
  createDisclaimer = () => {
    const { data, t } = this.props;
    const { currentSection } = this.state;
    const dataDisclaimer = _.get(
      data[0],
      `buttons[${currentSection}].disclaimer`
    );

    console.log("createDisclaimer", {
      data,
      dataDisclaimer,
      lang: t(dataDisclaimer),
    });
    return (
      <div className="disclaimer">
        <p>{t(dataDisclaimer)}</p>
      </div>
    );
  };
  handleClickImage = (key) => {
    console.log("TypeResidences - handleClickImage >>>> ", key);
    this.setState({
      showImageModal: true,
      currentImage: key,
    });
  };
  handleClick360 = (path) => {
    this.setState({
      showVirtualModal: true,
      currentURL: path,
    });
  };
  handleCloseModal = () => {
    this.setState({
      showImageModal: false,
      showVirtualModal: false,
      currentImage: 0,
    });
  };
  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  };
  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  };
  gotoImage = (index) => {
    this.setState({
      currentImage: index,
    });
  };
  render() {
    const {
      currentSection,
      showImageModal,
      showVirtualModal,
      currentImage,
      currentURL,
    } = this.state;
    const { data, viewBox, t } = this.props;
    const title = _.get(data[0], "name"); // _.get(data[0], `buttons[${currentSection}].name`);
    const des = _.get(data[0], `buttons[${currentSection}].description`);
    const sizeImage = _.size(
      _.get(data[0], `buttons[${currentSection}].image360`)
    );
    const sizeVirtual = _.size(
      _.get(data[0], `buttons[${currentSection}].imageVirtual`)
    );
    console.log("TypeResidences", data[0]);
    return (
      <div className="section-typeresidence">
        {currentSection === 0 && (
          <div className="section-typeresidence-crossimage">
            <Slider
              type="type-background"
              items={this.createSliderData()}
              uiRenderer={(item, index) => {
                return (
                  <div
                    key={index}
                    className="img-background"
                    style={{
                      backgroundImage: `url(${item.image})`,
                      backgroundPosition: _.get(
                        item,
                        "backgroundPosition",
                        "center center"
                      ),
                    }}
                  />
                );
              }}
            />
            <div className="typeresidence-alpha" />
            <div className="typeresidence-container-des title">
              <div className="typeresidence-title">
                <h2>{t(title)}</h2>
              </div>
              <div className="typeresidence-des">
                <h3 style={{ color: "#000000" }}>
                  <div dangerouslySetInnerHTML={{ __html: t(des) }} />
                </h3>
              </div>
            </div>
          </div>
        )}
        {currentSection !== 0 && (
          <div className="typeresidence-containall">
            <div className="typeresidence-container-imgtype">
              <svg
                // style={{ fill: "transparent", paddingTop: 50 }}
                style={{ fill: "transparent", paddingBottom: 80 }}
                // style={{ fill: "transparent", paddingBottom: 100 }}
                // width="80%"
                // height="80%"
                viewBox={`${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`}
              >
                <image
                  className="typeresidence-imgtype"
                  xlinkHref={t(
                    _.get(data[0], `buttons[${currentSection}].floorPlan`)
                  )}
                  x={0}
                  y={0}
                  width={1920}
                  height={1080}
                />
                {this.createimageImage()}
                {this.createimage360()}
              </svg>
              {this.createDisclaimer()}
            </div>
            <div className="typeresidence-container-des">
              <div className="typeresidence-title title">
                <h2 style={{ color: "#000000", fontSize: "18px" }}>
                  {t(title)}
                </h2>
              </div>
            </div>
            <div className="typeresidence-label">
              {sizeImage > 0 && (
                <div className="typeresidence-labelmock">
                  <div className="typeresidence-blocklabel">
                    <img
                      style={{ width: "60%", height: "auto" }}
                      src="/assets/images/icon-image.png"
                      alt=""
                    />
                  </div>
                  <div className="typeresidence-text black">
                    {t("View Images")}
                  </div>
                </div>
              )}
              {sizeVirtual > 0 && (
                <div className="typeresidence-labelmock">
                  <div className="typeresidence-blocklabel">
                    <img
                      style={{ width: "60%", height: "auto" }}
                      src="/assets/images/icon-360.png"
                      alt=""
                    />
                  </div>
                  <div className="typeresidence-text black">
                    {t("Virtual Tour")}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="typeresidence-container-btn">{this.createBtn()}</div>
        {showImageModal && (
          <Modal name="typeresidence-modal" onCancel={this.handleCloseModal}>
            <GalleryLightbox
              currentImage={currentImage}
              images={_.map(
                _.get(data[0], `buttons[${currentSection}].images`),
                (value) => {
                  return {
                    src: _.get(value, "image"),
                    caption: "",
                  };
                }
              )}
              onClickPrev={this.gotoPrevious}
              onClickNext={this.gotoNext}
              onClickThumbnail={this.gotoImage}
            />
          </Modal>
        )}

        {showVirtualModal && (
          <Modal
            name="residences-virtual-modal"
            onCancel={this.handleCloseModal}
          >
            {currentURL ? (
              <iframe
                title="tour"
                src={currentURL}
                width="100%"
                height="100%"
              />
            ) : (
              <ComingSoon />
            )}
          </Modal>
        )}
      </div>
    );
  }
}

export default TypeResidences;



// WEBPACK FOOTER //
// ./src/containers/TypeResidences.js